import { type ComponentProps, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import s from './FormattedHTMLMessage.module.scss';

type TMessageValues = ComponentProps<typeof FormattedMessage>['values'];

/** The parts react-intl passes to a rich text tag function. */
type TChunks = ReactNode[];

interface IFormattedHTMLMessageProps {
  id: string;
  defaultMessage?: string;
  values?: TMessageValues;
}

// The keys are the stringified chunks, as React stringifies any key.
const FormattedHTMLMessage = ({ id, defaultMessage = ' ', values }: IFormattedHTMLMessageProps) => (
  <FormattedMessage
    id={id}
    defaultMessage={defaultMessage}
    values={{
      p: (...chunks: TChunks[]) => <p key={String(chunks)}>{chunks}</p>,
      b: (...chunks: TChunks[]) => <b key={String(chunks)}>{chunks}</b>,
      ul: (...chunks: TChunks[]) => (
        <ul key={String(chunks)} className={s.list}>
          {chunks}
        </ul>
      ),
      li: (chunks: TChunks) => (
        <li key={String(chunks)} className={s.listItem}>
          {chunks}
        </li>
      ),
      ...values,
    }}
  />
);

export default FormattedHTMLMessage;
